import { useSelector } from 'react-redux'
import { i18n, selectI18nRevision } from '@/locale/i18n'

/**
 * Use in components that call i18n() so they re-render when the active
 * language changes or the Portuguese dictionary finishes loading.
 */
export default function useI18n() {
  useSelector(selectI18nRevision)
  return i18n
}
